import styled from "styled-components";
import { photoAnim, fade, pageAnimation } from "../../Animation";
import { motion } from "framer-motion";
import { useScroll } from "../../hooks/UseScroll";
import ScrollOrigin from "../ScrollOrigin";

const Story = () => {
  const [element, controls] = useScroll();
  const [element2, controls2] = useScroll();
  return (
    <motion.div
      exit="exit"
      variants={pageAnimation}
      initial="hidden"
      animate="show"
    >
      <StyledImage>
        <motion.img
          ref={element}
          variants={photoAnim}
          animate={controls}
          loading="lazy"
          initial="hidden"
          src="../../img/portfolioPicture.jpg"
          alt="Daniel Mason smiling"
        />
        <motion.span
          ref={element2}
          variants={fade}
          animate={controls2}
          initial="hidden"
        >
          <StyledStory>
          <h1 className="story-intro">About Me.</h1>
          <hr/>
          <br/>
            <p>
              I'm a curious, passionate, and goal-oriented person with a growth mindset who enjoys building new
              things, learning different topics, and sharing them with others.
            </p>
            <br />
            <p>
              As an experienced full stack software developer, with a decade
              long career in the culinary arts as apart of & leading
              cross-functional teams. I really enjoy working with different people from
              all walks of life, and am comfortable with working under pressure
              with short deadlines.
            </p>
            <br />
            <p>
              In my personal time, I enjoy a good cup of coffee, reading,
              going on bike rides during the summer, and mentoring others in the tech industry. 
              Moreover, I enjoy working on open source projects in collaboration with those in my network, or whom
              I've worked with or went to school with.
            </p>
          </StyledStory>
        </motion.span>
      </StyledImage>
      <ScrollOrigin />
    </motion.div>
  );
};

const StyledImage = styled.div`
  display: flex;
  flex-direction: row;
  align-items: anchor-center;
  justify-content: center;
  gap: 2rem;
  padding: 2rem 4rem;
  max-width: 100vw;
  margin: 0 auto;

  img {
    width: 40vw;
    height: 80vh;
    max-height: 90vh;
    object-fit: cover;
    border-radius: 1rem;
    flex-shrink: 0;
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: center;

    img {
      width: 80%;
      max-height: 60vh;
    }
  }

  @media (max-width: 480px) {
    padding: 1rem;

    img {
      width: 90%;
      max-height: 60vh;
    }
  }
`;


const StyledStory = styled.div`
  flex: 1;
  max-width: 50vw;
  text-align: left;
  line-height: 1.8rem;
  font-size: 1.75rem;
  font-weight: normal;

  h1.story-intro {
    font-size: 3rem;
    margin-bottom: 1rem;
  }

  h2 {
    font-size: 1.75rem;
    margin-bottom: 1rem;
  }

  p {
    margin-bottom: 1.05rem;
    color: ${(props) => props.theme.fontColor};
    font-size: 1.5rem;
  }

  @media (max-width: 1150px) {
    max-width: 90%;
    text-align: center;

    h1.story-intro,
    h2 {
      text-align: center;
    }
  }

  @media (max-width: 480px) {
    h1.story-intro {
      font-size: 2rem;
    }

    h2 {
      font-size: 1.75rem;
    }

    p {
      font-size: 1.5rem;
      font-weight: 400;
    }
  }
`;

export default Story;
